import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

// ---------------------------------------------------------

import Icon from '@components/icon';
import Image from '@components/image';
import ContactForm from '@components/form';
import Link from '@components/link';
import useWindowSize from '@lib/window-size';

// ---------------------------------------------------------

import styles from './styles.module.scss';
const {
  container,
  inner,
  header,
  cc_logo,
  text,
  phone_number,
  contact,
  contact_content,
  contact_link
} = styles;

// ---------------------------------------------------------

const BrokerReciprocityCard = (props) => {
  const { hasTour, listingId, defaultCommentValue, sticky, setModalIsOpen } = props;

  const router = useRouter();
  const ref = useRef();
  const [referenceHeight, setReferenceHeight] = useState(0);

  useEffect(() => {
    setReferenceHeight(ref.current?.clientHeight || 0);
  }, []);

  useEffect(() => {
    if (hasTour && router?.isReady) {
      setModalIsOpen(!!router?.query?.tourModal);
    }
  }, [router]);

  // ---------------------------------------------------------

  return (
    <div
      className={container}
      ref={ref}
      style={{
        position: referenceHeight + 50 < useWindowSize().height && sticky ? 'sticky' : 'inherit',
        top: referenceHeight + 50 < useWindowSize().height && sticky ? '20px' : '0px'
      }}
    >
      <div className={inner}>
        <h2 className={header}>Ask a Question</h2>
        <div className={text}>
          Contact our Customer Care team{' '}
          {hasTour && (
            <>
              or{' '}
              <button onClick={() => setModalIsOpen(true)} rel="noreferrer">
                request a tour!
              </button>
            </>
          )}
        </div>
        <div className={phone_number}>
          <Link url={`tel:513-985-4010`} dataLayerEvent="listing_call_click">
            513-985-4010
          </Link>
        </div>
      </div>
      <div className={contact_content}>
        <span className={contact_link}>
          <Link url={`tel:513-985-4010`} dataLayerEvent="listing_call_click">
            <Icon name="phone" type="actions" />
            Call
          </Link>
        </span>
        <span className={contact_link}>
          <Link url={`sms:513-985-4010`} dataLayerEvent="listing_text_click">
            <Icon name="text" type="actions" />
            Text
          </Link>
        </span>

        {hasTour && (
          <span className={contact_link}>
            <button onClick={() => setModalIsOpen(true)}>
              <Icon type="general" name="clock" />
              Tour
            </button>
          </span>
        )}
      </div>
      <ContactForm
        submitLabel="Send Message"
        requestType="Listing"
        defaultCommentValue={defaultCommentValue}
        agentIds={[]}
        listingId={listingId}
      ></ContactForm>

      <div className={cc_logo}>
        <Image
          image={{
            height: '14px',
            src: '/storybook/customercare@3x.jpg',
            width: '145px'
          }}
          layout="fixed"
        />
      </div>

      <Link url="tel:513-985-4010" className={contact} dataLayerEvent="listing_call_click">
        <Icon type="actions" name="phone" />
        <span>Call us now at 513-985-4010</span>
      </Link>
    </div>
  );
};

BrokerReciprocityCard.propTypes = {
  // Specifies the contact form comment default form value
  defaultCommentValue: PropTypes.string,

  /**
   * Specifies if the listing is available to tour
   */
  hasTour: PropTypes.bool,

  /**
   * Hides the buttons/links for the in-modal card.
   */
  hideLinks: PropTypes.bool,

  /**
   * The listing ID
   */
  listingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Function to open the request a tour modal
   */
  setModalIsOpen: PropTypes.func,

  /**
   * Specifies whether the card is sticky.
   */
  sticky: PropTypes.bool,

  /**
   * Url that opens the Showing Time interface in a new window (no button if no url).
   */
  tourUrl: PropTypes.string,

  /**
   * Specifies the logged in user's information
   */
  userInfo: PropTypes.object
};

export default BrokerReciprocityCard;
